import { documentElementClipController } from "./document-element-clip-controller.js";
const DocumentElementClipMixin = (superClass) => {
  class DocumentElementClipEl extends superClass {
    constructor() {
      super();
      this.__docElClipRefCount = 0;
    }
    disconnectedCallback() {
      documentElementClipController.unclip();
    }
    _clipDocumentElement() {
      documentElementClipController.clip();
      this.__docElClipRefCount += 1;
    }
    _unclipDocumentElement() {
      const prevDocElClipRefCount = this.__docElClipRefCount;
      this.__docElClipRefCount = Math.max(0, this.__docElClipRefCount - 1);
      if (this.__docElClipRefCount === prevDocElClipRefCount) return;
      documentElementClipController.unclip();
    }
  }
  return DocumentElementClipEl;
};
export {
  DocumentElementClipMixin
};
//# sourceMappingURL=document-element-clip-mixin.js.map
